// src/Components/Ideal_Logout.js
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

const IDLE_TIME = 3 * 60 * 60 * 1000; // 3 Hour

const useIdleLogout = () => {
  const navigate = useNavigate();
  const timerRef = useRef(null);

  const logout = () => {
    localStorage.clear();   // enough, no need multiple remove
    navigate("/");
  };

  const resetTimer = () => {
    if (timerRef.current) clearTimeout(timerRef.current);

    timerRef.current = setTimeout(() => {
      logout();
    }, IDLE_TIME);
  };

  useEffect(() => {
    const activityEvents = ["mousemove", "keydown", "click", "scroll", "touchstart", "touchmove"];

    // reset timer on user activity
    activityEvents.forEach(event =>
      window.addEventListener(event, resetTimer)
    );

    // 🔁 multi-tab logout sync
    const handleStorageChange = (e) => {
      if (e.key === "isLoggedIn" && e.newValue === null) {
        navigate("/");
      }
    };
    window.addEventListener("storage", handleStorageChange);

    resetTimer(); // start timer when app loads

    return () => {
      activityEvents.forEach(event =>
        window.removeEventListener(event, resetTimer)
      );
      window.removeEventListener("storage", handleStorageChange);
      clearTimeout(timerRef.current);
    };
  }, [navigate]);
};

export default useIdleLogout;
